"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background px-4 py-20">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/starfield_background.png)] bg-cover bg-center opacity-20 animate-[drift_60s_ease-in-out_infinite]" />

      {}
      <div className={`
          relative z-10 max-w-3xl w-full
          bg-surface/80 backdrop-blur-md
          rounded-lg shadow-strong
          border border-muted
          p-8 md:p-12
          text-center
          transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        {}
        <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
          Engager une Conversation Stratégique
        </h2>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">
          Collaborez avec NorthStar Advisory pour maîtriser la complexité et créer une valeur durable.
        </p>

        {}
        <Link to="#contact">
          <Button className="
              btn-primary
              group relative
              hover:scale-[1.03]
              focus-visible:ring-2 focus-visible:ring-ring
              transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]
            ">
            <span className="relative z-10">On en parle</span>
            <span className="
                absolute bottom-0 left-1/2 -translate-x-1/2
                h-[2px] w-0 bg-accent
                group-hover:w-full group-focus-visible:w-full
                transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
              " />
          </Button>
        </Link>
      </div>

      {}
      <style jsx>{`
        @keyframes drift {
          0%, 100% {
            transform: translate(0, 0);
          }
          50% {
            transform: translate(20px, 10px);
          }
        }
      `}</style>
    </section>;
}